'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["category", "superCategory", "categoryV2", "page"];
import memoize from 'hs-lodash/memoize';
import * as SuperCategory from 'marketplace-ui-apps-core/common/constants/groupTags/SuperCategory';
import * as GROUPED_CATEGORIES from 'marketplace-ui-apps-core/common/constants/groupTags/SuperCategoryGroup';
import * as CategorySlug from 'marketplace-ui-apps-core/common/constants/urlSlugs/CategorySlug';
import { CategoryV2Slug } from 'marketplace-ui-apps-core/common/constants/urlSlugs/CategoryV2Slug';
import * as SuperCategorySlug from 'marketplace-ui-apps-core/common/constants/urlSlugs/SuperCategorySlug';
import * as Category from 'marketplace-ui-common/constants/groupTags/Category';
const getCategoryFromSlug = memoize(slug => {
  return Object.keys(Category).find(key => CategorySlug[key] === slug);
});
const getSuperCategoryFromSlug = memoize(slug => {
  return Object.keys(SuperCategory).find(key => SuperCategorySlug[key] === slug);
});
const getCategoryV2FromSlug = memoize(slug => {
  return Object.keys(CategoryV2Slug).find(key => CategoryV2Slug[key] === slug);
});
export const getParsedPathParams = _ref => {
  let {
      category,
      superCategory,
      categoryV2,
      page
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, rest, {
    category: getCategoryFromSlug(category),
    superCategory: getSuperCategoryFromSlug(superCategory),
    categoryV2: getCategoryV2FromSlug(categoryV2),
    page: page ? parseInt(page, 10) : undefined
  });
};
export const getIsAllReviews = match => match.path.endsWith('/:slug/reviews') && match.isExact;
export const hasValidCategoryParam = params => {
  const {
    category,
    superCategory
  } = getParsedPathParams(params);
  if (!(category && superCategory)) {
    return false;
  }
  const superCategoryGroup = GROUPED_CATEGORIES[superCategory];
  return superCategoryGroup && superCategoryGroup.includes(category);
};